<form
  [formGroup]="form"
  class="klab-recover-pass-card"
  (ngSubmit)="onPrimaryClick()"
>
  <header class="klab-recover-pass-card__header">
    <div class="klab-recover-pass-card__logo">Klab<span>*</span></div>
  </header>

  <div
    class="klab-recover-pass-card__container"
    [ngClass]="{
      'klab-recover-pass-card__container--success': step === 'success',
    }"
  >
    <div class="klab-recover-pass-card__content">
      <h2 class="klab-recover-pass-card__title">{{ title }}</h2>
      <div class="klab-recover-pass-card__detail">
        <span class="klab-recover-pass-card__subtitle">{{ subtitle }}</span>
        <span class="klab-recover-pass-card__description">{{
          description
        }}</span>
      </div>
    </div>

    <div class="klab-recover-pass-card__control" [ngSwitch]="step">
      <ng-container *ngSwitchCase="'email'">
        <core-ui-input-text
          label="Correo"
          placeholder="Ingresa tu correo electrónico"
          formControlName="username"
        >
        </core-ui-input-text>
      </ng-container>

      <ng-container *ngSwitchCase="'code'">
        <div class="klab-recover-pass-card__code-wrapper">
          <core-ui-input-otp formControlName="code"></core-ui-input-otp>
          <div class="klab-recover-pass-card__otp-resend">
            <span class="klab-recover-pass-card__otp-resend-label"
              >Reenviar código en</span
            >
            <span class="klab-recover-pass-card__otp-resend-time">{{
              formattedTime
            }}</span>
            <button
              *ngIf="canResend"
              type="button"
              class="klab-recover-pass-card__otp-resend-btn"
              (click)="onResendClick()"
            >
              Reenviar
            </button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'validating'">
        <div class="klab-recover-pass-card__loader">
          <div class="klab-recover-pass-card__loader-spinner">
            <div class="klab-recover-pass-card__loader-dot"></div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'newPassword'">
        <div class="klab-recover-pass-card__password-group">
          <core-ui-input-text
            label="Contraseña nueva"
            placeholder="Ingresa tu contraseña"
            type="password"
            formControlName="newPassword"
            iconRight="Eye_off"
            [helperMessage]="passwordHint"
            [errorMessage]="getPasswordError('newPassword')"
          >
          </core-ui-input-text>
          <core-ui-input-text
            label="Repetir contraseña"
            placeholder="Confirma tu nueva contraseña"
            type="password"
            formControlName="confirmPassword"
            iconRight="Eye_off"
            [helperMessage]="passwordHint"
            [errorMessage]="getPasswordError('confirmPassword')"
          >
          </core-ui-input-text>
        </div>
      </ng-container>
    </div>

    <div class="klab-recover-pass-card__actions">
      <core-ui-button-base
        variant="primary"
        size="lg"
        [block]="true"
        [disabled]="primaryButtonDisabled"
        type="submit"
        >{{ primaryButtonLabel }}</core-ui-button-base
      >
      <div class="klab-recover-pass-card__back-wrap" *ngIf="step !== 'success'">
        <core-ui-button-base
          size="md"
          type="button"
          [block]="true"
          [stretch]="true"
          (click)="onGoBack()"
          variant="solid"
          color="blue"
          >Volver al inicio de sesión</core-ui-button-base
        >
      </div>
      <div class="klab-recover-pass-card__terms" *ngIf="showTerms">
        <span>Al continuar, acepta nuestros </span>
        <span class="klab-recover-pass-card__terms-link"
          >Términos y Políticas de privacidad.</span
        >
      </div>
    </div>
  </div>
</form>
